module.exports = __webpack_public_path__ + "5173efe015dad4dcbb48d9b69de0d44f.jpg";